/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconWatch(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m4.347 1.122-.403 1.899A2.25 2.25 0 0 0 2 5.25v5.5a2.25 2.25 0 0 0 1.944 2.23l.403 1.898c.14.654.717 1.122 1.386 1.122h4.535c.668 0 1.246-.468 1.385-1.122l.404-1.899A2.25 2.25 0 0 0 14 10.75v-5.5a2.25 2.25 0 0 0-1.943-2.23l-.404-1.898A1.417 1.417 0 0 0 10.267 0H5.734c-.67 0-1.247.468-1.386 1.122zM5.8 1.5h4.4l.319 1.5H5.48l.32-1.5zM10.52 13l-.319 1.5H5.8L5.481 13h5.038zM4.25 4.5h7.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-5.5a.75.75 0 0 1 .75-.75z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M6.916 1.584A2 2 0 0 1 8.873 0h6.4a2 2 0 0 1 1.957 1.584l.761 3.584A3.001 3.001 0 0 1 20 8v8a3 3 0 0 1-2.009 2.832l-.761 3.584A2 2 0 0 1 15.273 24h-6.4a2 2 0 0 1-1.957-1.584l-.75-3.534A3.001 3.001 0 0 1 4 16V8c0-1.367.915-2.52 2.165-2.882l.751-3.534zM8.235 5h7.676l-.637-3H8.873l-.638 3zm0 14 .638 3h6.4l.638-3H8.235zM7 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconWatch is deprecated and will be archived soon. Use IconWatch instead.
 */
export function Experimental__IconWatch(props) {
  return /*#__PURE__*/React.createElement(IconWatch, props);
}